<template>
  <div v-if="isCardRealShow" class="resultv2_business_card card-function-bar card-function-bar-v2">
    <div class="card-wrap">
      <div class="card-item card-user">
        <name-card :name-card-infor="data" @click="jumpTo(data.nameCard)" />
      </div>
      <div
        :class="{
          'card-item': true,
          'card-telephone': true,
          'line': !bApp && !isToB
        }"
      >
        <a
          :href="`tel:${data.telephone}`"
          data-stat-id="phone"
          :style="!bApp ? 'text-align: center': ''"
          :data-stat-ep="JSON.stringify({ productId: data.insuranceTypeId })"
        >
          <template v-if="bApp">
            {{ data.telephone }}
          </template>
          <template v-else>
            <i class="iconfont icon-phone_line" />
            <span>联系我</span>
          </template>
        </a>
      </div>
      <div
        v-show="isScreenCapture"
        :class="{
          'card-item': true,
          'card-edit': bApp,
          'card-view': !bApp,
        }"
      >
        <a
          href="javascript:;"
          data-stat-id="edit"
          :data-stat-ep="JSON.stringify({ productId: data.insuranceTypeId })"
          @click="onClickBusinessCard"
        >
          <span v-if="bApp" class="inner">编辑名片</span>
          <template v-else>
            <i class="iconfont icon-business_card" />
            <span>查看名片</span>
          </template>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { bApp, isBroker, isToB, isWeCom } from 'base/config'
import { getUrlParam, getUrlByAddingParam } from 'common/js/common'
import NameCard from '@/components/footer/nameCard.vue'

export default {
  components: {
    NameCard
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isScreenCapture: {
      type: Boolean,
      default: false
    },
    isPolicyCheck: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      bApp: bApp,
      isToB: isToB,
      isCardShow: true,
    }
  },
  computed: {
    isCardRealShow () {
      const { isCardShow, data, isPolicyCheck } = this
      return isCardShow && data.photo && !isPolicyCheck && !isWeCom
    }
  },
  created () {
    const nocard = getUrlParam('nocard')
    const uuid = getUrlParam('uuid')
    const theme = getUrlParam('theme')
    if (Number(nocard) === 1 || isBroker) {
      this.isCardShow = false
    }
    const sourceFrom = JSON.stringify({ uuid, theme })
    this.data.nameCard = getUrlByAddingParam({ sourceFrom }, this.data.nameCard)
  },
  methods: {
    onClickBusinessCard () {
      const url = bApp ? this.data.nameCardEdit : this.data.nameCard
      this.jumpTo(url)
    },
    jumpTo (url) {
      if (!url) {
        return
      }
      location.href = url
    }
  }
}
</script>

<style>
  @import './index.css';
</style>